import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiStudentLogin, apiStudentVerifyPassword } from '../lib/studentApi';
import { useStudentSession } from '../context/StudentContext';

export default function StudentLogin() {
  const navigate = useNavigate();
  const { setSession } = useStudentSession();

  const [step, setStep]       = useState<'phone' | 'password'>('phone');
  const [email, setEmail]     = useState('');
  const [phone, setPhone]     = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handlePhoneSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiStudentLogin(email.trim(), phone.trim());
      if (res.isFirstLogin) {
        navigate('/student/set-password', { state: { email: email.trim(), phone: phone.trim(), name: res.name } });
      } else {
        setStep('password');
      }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiStudentVerifyPassword(email.trim(), password);
      setSession({ studentId: res.studentId, name: res.name, email: res.email, mentorId: res.mentorId, course: res.course, studentToken: res.studentToken });
      navigate('/student/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#f5f5f5' }}>
      <div className="w-full max-w-sm mx-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4" style={{ background: '#2b2240' }}>
            <span className="text-2xl font-black" style={{ color: '#F0B429' }}>VT</span>
          </div>
          <h1 className="text-2xl font-black" style={{ color: '#2b2240' }}>Student Portal</h1>
          <p className="text-sm text-gray-500 mt-1">VistaTech Solutions</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          {step === 'phone' ? (
            <>
              <h2 className="text-base font-bold mb-1" style={{ color: '#2b2240' }}>Sign In</h2>
              <p className="text-xs text-gray-500 mb-5">Enter your registered email and phone number</p>
              <form onSubmit={handlePhoneSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Email Address</label>
                  <input
                    type="email" required value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-yellow-400"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Phone Number</label>
                  <input
                    type="tel" required value={phone} onChange={e => setPhone(e.target.value)}
                    placeholder="9xxxxxxxxx"
                    className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-yellow-400"
                  />
                </div>
                {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
                <button type="submit" disabled={loading}
                  className="w-full py-3 rounded-xl text-sm font-bold text-white disabled:opacity-50"
                  style={{ background: '#2b2240' }}>
                  {loading ? 'Checking…' : 'Continue'}
                </button>
              </form>
            </>
          ) : (
            <>
              <button onClick={() => { setStep('phone'); setError(''); }} className="text-xs text-gray-400 hover:text-gray-600 mb-4 flex items-center gap-1">
                ← Back
              </button>
              <h2 className="text-base font-bold mb-1" style={{ color: '#2b2240' }}>Enter Password</h2>
              <p className="text-xs text-gray-500 mb-5">{email}</p>
              <form onSubmit={handlePasswordSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Password</label>
                  <input
                    type="password" required value={password} onChange={e => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-yellow-400"
                  />
                </div>
                {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
                <button type="submit" disabled={loading}
                  className="w-full py-3 rounded-xl text-sm font-bold text-white disabled:opacity-50"
                  style={{ background: '#2b2240' }}>
                  {loading ? 'Signing in…' : 'Sign In'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
